module.exports = __webpack_public_path__ + "static/media/edu5.ab470646.jpg";